export function HeaderText({ title, subtitle }) {
  return (
    <div className="mb-4">
      <h2 className="text-xl font-bold">{title}</h2>
      <p className="text-gray-500">{subtitle}</p>
         
    </div>
  );
}
